import { useState } from 'react'
import { useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { NavLink, useNavigate } from 'react-router-dom'
import { CaretLeft, CheckCircle, XCircle } from 'phosphor-react'
import { type FiltersDomain } from '../../../../../types/domain/filters-domain'

import { SearchInput } from '../../../../../components/SearchInput'
import { useMediaQuery } from '../../../../../hooks/useMediaQuery'
import { Medias } from '../../../../../enumns/medias'
import { ScrollArquivedProjectsContainer } from './components/ScrollArchivedProjectsContainer'
import { ManualArchivedProjectPaginationContainer } from './components/ManualArchivedProjectPaginationContainer'

import { useProjectToFileMutation } from '../../../../../services/hooks/projects/mutations/useProjectToFileMutation'
import { UnarquiveProjectModal } from './components/UnarchiveProjectModal'
import { type ProjectDomain } from '../../../../../types/domain/project-domain'

export const ArchivedProjects = () => {
  const isMinScreenWidthLG = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [idProject, setIdProject] = useState<number>()
  const [isUnarquiveModalOpen, setIsUnarchiveModalOpen] = useState(false)
  const [filters, setFilters] = useState<FiltersDomain>({
    page: 1,
    take: isMinScreenWidthLG ? 10 : 15,
    search: '',
    isFiled: true,
  })

  const { mutate: toFileMutation, isLoading: isUnarchivingProject } =
    useProjectToFileMutation()

  const handleSearch = (term: string) => {
    setFilters((prevState) => ({
      ...prevState,
      page: 1,
      search: term,
    }))
  }

  const handleCloseUnarquiveProjectModal = () => {
    setIsUnarchiveModalOpen(false)
  }

  const handleOpenUnarquiveProjectModal = ({ id }: ProjectDomain) => {
    setIsUnarchiveModalOpen(true)
    setIdProject(id)
  }

  const handleUnarquiveProject = () => {
    if (idProject) {
      toFileMutation(idProject, {
        onSuccess() {
          queryClient.invalidateQueries(['projects'])
          queryClient.invalidateQueries(['filed-projects'])
          handleCloseUnarquiveProjectModal()
          navigate('/painel/projects/archived')
          toast('Projeto desarquivado com sucesso!', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            closeButton: false,
            icon: (
              <CheckCircle
                size={48}
                className="mx-auto my-auto text-alert-success"
              />
            ),
            className: 'bg-green-50',
          })
        },
        onError(error: any) {
          toast.error(error, {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            closeButton: false,
            icon: (
              <XCircle size={48} className="mx-auto my-auto text-alert-error" />
            ),
            className: 'bg-red-50',
          })
        },
      })
    }
  }

  return (
    <>
      <div className="lg:mr-6">
        {!isMinScreenWidthLG && (
          <div className="flex flex-col mb-6">
            <NavLink to={'/painel/projects'}>
              <CaretLeft size={28} color="#8D8D8D" />
            </NavLink>
          </div>
        )}

        <div className="flex flex-col gap-6 mb-6 lg:gap-0 lg:flex-row lg:items-center lg:justify-between">
          <p className="text-base font-semibold  lg:font-medium lg:text-lg">
            Projetos Arquivados
          </p>
          <SearchInput
            onSearch={handleSearch}
            placeholder="Buscar por nome, número ou empresa"
            className="w-full lg:w-96"
          />
        </div>

        {isMinScreenWidthLG ? (
          <ManualArchivedProjectPaginationContainer
            filters={filters}
            setFilters={setFilters}
            onArquivedProjectItemClick={handleOpenUnarquiveProjectModal}
          />
        ) : (
          <ScrollArquivedProjectsContainer
            filters={filters}
            setFilters={setFilters}
            onArquivedProjectItemClick={handleOpenUnarquiveProjectModal}
          />
        )}
      </div>

      <UnarquiveProjectModal
        isOpen={isUnarquiveModalOpen}
        onClose={handleCloseUnarquiveProjectModal}
        isUnarchivingProject={isUnarchivingProject}
        onUnarquiveProject={handleUnarquiveProject}
      />
    </>
  )
}
